import {
    CONFIRM_BOOKING,
    CONFIRM_BOOKING_SUCCESS,
    CONFIRM_BOOKING_FAILED,
    CLEAR_BOOKING
} from "../store/types";
import { RequestPushMsg } from '../other/NotificationFunctions';
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { formatBookingObject } from '../other/sharedFunctions';
import { get, onValue, push, set, update } from "firebase/database";

export const clearBooking = () => (dispatch) => {
    dispatch({
        type: CLEAR_BOOKING,
        payload: null,
    });
}

export const addBooking = (bookingData) => async (dispatch) => {

    const   {
        bookingRef,
        settingsRef,
        singleUserRef
    } = firebase;

    dispatch({
        type: CONFIRM_BOOKING,
        payload: bookingData,
    });

    const settingsdata = await get(settingsRef);
    const settings = settingsdata.val();

    let data = await formatBookingObject(bookingData, settings);

    if(bookingData.requestedDrivers){
        const drivers = bookingData.requestedDrivers;
        Object.keys(drivers).map((uid)=>{
            onValue(singleUserRef(uid),  snapshot => {
                if (snapshot.val()) {
                    const pushToken = snapshot.val().pushToken;
                    const ios = snapshot.val().userPlatform == "IOS"? true: false
                    if(pushToken){
                        RequestPushMsg(
                            pushToken,
                            {
                                title: store.getState().languagedata.defaultLanguage.notification_title,
                                msg: store.getState().languagedata.defaultLanguage.new_booking_notification,
                                screen: 'DriverTrips'
                            });
                     }
                 }
            }, {onlyOnce: true});
            return drivers[uid];
        })
    }

    push(bookingRef, data).then((res) => {
        var bookingKey = res.key;
        dispatch({
            type: CONFIRM_BOOKING_SUCCESS,
            payload: {
                booking_id:bookingKey,
                mainData:{
                    ...data,
                    id:bookingKey
                }
            }    
        });
    }).catch(error => {
        dispatch({
            type: CONFIRM_BOOKING_FAILED,
            payload: error.code + ": " + error.message,
        });
    });
};


const postFunction = async (name, payload) => {
  const { auth, config } = firebase;
  const user = auth.currentUser;
  if (!user) return { ok: false, error: 'Unauthorized' };
  const settings = store.getState().settingsdata.settings;
  const host = typeof window !== 'undefined' && window.location && settings && settings.CompanyWebsite === window.location.origin ? window.location.origin : `https://${config.projectId}.web.app`;
  try {
    const idToken = await user.getIdToken();
    const response = await fetch(`${host}/${name}`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + idToken }, body: JSON.stringify({ data: JSON.stringify(payload) }) });
    // The endpoints always answer JSON (errors too). Anything else (e.g. the web app's index.html when the Hosting
    // rewrite is missing) means the function is not reachable at this URL.
    const type = response.headers && response.headers.get ? String(response.headers.get('content-type') || '') : '';
    if (type.indexOf('application/json') < 0) return { ok: false, error: 'endpoint_unavailable' };
    let json;
    try {
      json = await response.json();
    } catch (parseError) {
      return { ok: false, error: 'endpoint_unavailable' };
    }
    if (json && json.error) return { ok: false, error: json.error };
    if (!response.ok) return { ok: false, error: 'endpoint_unavailable' };
    return Object.assign({ ok: true }, json);
  } catch (e) {
    return { ok: false, error: 'network_error' };
  }
};

export const acceptBid = (params) => async (dispatch) => postFunction('accept_bid', { bookingId: params.bookingId, driver: params.driver, payment_mode: params.payment_mode, promo_code: params.promo_code || undefined, wallet_hold: params.wallet_hold === true ? true : undefined });

export const payPendingBooking = (bookingId) => async (dispatch) => postFunction('pay_pending_booking', { bookingId });

export const placeBid = (bookingId, { bidPrice, driverDeviceId }) => async (dispatch) => {
  const { auth, driverOfferRef } = firebase;
  const user = auth.currentUser;
  if (!user) return { ok: false, error: 'Unauthorized' };
  const price = parseFloat(bidPrice);
  if (!(price > 0)) return { ok: false, error: 'no_details_error' };
  const profile = store.getState().auth.profile || {};
  const bid = {
    driver: user.uid,
    bidPrice: price,
    trip_cost: price,
    driver_name: profile.firstName + ' ' + profile.lastName,
    driver_image: profile.profile_image ? profile.profile_image : "",
    car_image: profile.car_image ? profile.car_image : "",
    driver_contact: profile.mobile,
    driver_token: profile.pushToken ? profile.pushToken : '',
    vehicle_number: profile.vehicleNumber ? profile.vehicleNumber : "",
    vehicleModel: profile.vehicleModel ? profile.vehicleModel : "",
    vehicleMake: profile.vehicleMake ? profile.vehicleMake : "",
    driverRating: profile.rating ? profile.rating : "0",
    driverDeviceId: driverDeviceId
  };
  try {
    await set(driverOfferRef(bookingId, user.uid), bid);
    return { ok: true };
  } catch (e) {
    return { ok: false, error: e && e.code ? e.code : 'bid_failed' };
  }
};

export const withdrawBid = (bookingId) => async (dispatch) => {
  const { auth, rootRef } = firebase;
  const user = auth.currentUser;
  if (!user) return { ok: false, error: 'Unauthorized' };
  const updates = {};
  updates['bookings/' + bookingId + '/driverOffers/' + user.uid] = null;
  updates['bookings/' + bookingId + '/requestedDrivers/' + user.uid] = null;
  try {
    await update(rootRef(), updates);
    return { ok: true };
  } catch (e) {
    return { ok: false, error: e && e.code ? e.code : 'withdraw_failed' };
  }
};